import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import {
  ForgotPassword,
  Profile,
  ForgotPasswordSuccess,
  Login,
  NeedHelp,
  ResetPassword,
  Nomination,
  Home,
  NominationRequest,
  AcceptNomination,
  OutstandingPayment,
  Notification,
  Voting,
  ConfirmDetails,
  InformationCenter,
  CandidateProfile,
  ElectionResults,
  VotingLocation,
  CandidateList,
  NominationDetails,
  TermsAndConditions,
  Endorsement,
  NominationOutstandingPayment,
  EndorsementDetails,
  TermsAndConditions2025,
} from "./screens";
import Layout from "./components/dashboard/main";
import LandingPage from "./components/authLayout/landingPage";
import ProtectedRoute from "./hooks/protectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-password-success" element={<ForgotPasswordSuccess />} />
        {/* <Route path="/electoral-guidelines" element={<TermsAndConditions />} /> */}
        <Route path="/electoral-guidelines" element={<TermsAndConditions2025 />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidate-profile/:id"
          element={
            <ProtectedRoute>
              <CandidateProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/election-results"
          element={
            <ProtectedRoute>
              <ElectionResults />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/nomination" element={<Nomination />} /> */}
        {/* <Route path="need-help" element={<NeedHelp />} /> */}

        {/* <Route path="notification" element={ <ProtectedRoute><Notification /></ProtectedRoute> } /> */}
        {/* <Route path="voting" element={ <ProtectedRoute><Voting /></ProtectedRoute> } />
        <Route path="/location" element={<ProtectedRoute><VotingLocation /></ProtectedRoute>}/> */}

        <Route path="information-center" element={<InformationCenter />} />
        <Route
          path="/*"
          element={
            <LandingPage>
              <Routes>
                <Route path="need-help" element={<NeedHelp />} />
                <Route
                  path="outstanding-payment"
                  element={
                    <ProtectedRoute>
                      <OutstandingPayment />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="confirm-details"
                  element={
                    <ProtectedRoute>
                      <ConfirmDetails />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </LandingPage>
          }
        />
        <Route
          path="/nomination/*"
          element={
            <Layout pageHeading="Nomination">
              <Routes>
                <Route
                  path=""
                  element={
                    <ProtectedRoute>
                      <Nomination />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="request/:id"
                  element={
                    <ProtectedRoute>
                      <NominationRequest />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="accept/:id"
                  element={
                    <ProtectedRoute>
                      <AcceptNomination />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="details/:id"
                  element={
                    <ProtectedRoute>
                      <NominationDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="endorsement"
                  element={
                    <ProtectedRoute>
                      <Endorsement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="outstanding-payment"
                  element={
                    <ProtectedRoute>
                      <NominationOutstandingPayment />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="endorsement-details"
                  element={
                    <ProtectedRoute>
                      <EndorsementDetails />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          }
        />

        <Route
          path="/voting/*"
          element={
            <Layout pageHeading="Voting">
              <Routes>
                <Route
                  path=""
                  element={
                    <ProtectedRoute>
                      <Voting />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="location"
                  element={
                    <ProtectedRoute>
                      <VotingLocation />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="candidate-list"
                  element={
                    <ProtectedRoute>
                      <CandidateList />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
